import { render, staticRenderFns } from "./gasCouponInfo.vue?vue&type=template&id=6c65a22c&scoped=true&"
import script from "./gasCouponInfo.vue?vue&type=script&lang=js&"
export * from "./gasCouponInfo.vue?vue&type=script&lang=js&"
import style0 from "./gasCouponInfo.vue?vue&type=style&index=0&id=6c65a22c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c65a22c",
  null
  
)

export default component.exports